import React from 'react';

const InputWithCounter = ({
  value,
  maxLength,
  onChange,
  label,
  multiline = false,
  rows = 3,
  compact = false,
  flush = false,
  placeholder,
}) => {
  const inputClasses = flush
    ? 'block w-full rounded-[18px] border border-[#d7deef] bg-white px-4 py-3 text-[14px] leading-6 text-[#24324d] shadow-none outline-none transition-all duration-200 placeholder:text-[#99a4bc] hover:border-[#c8d3fb] hover:bg-[#fbfcff] focus:border-[#b7c5ef] focus:bg-white focus:ring-4 focus:ring-[rgba(74,92,255,0.08)] sm:text-sm'
    : 'block w-full rounded-[14px] border border-[#d7deef] bg-white px-4 py-3 text-[14px] leading-6 text-[#24324d] shadow-none outline-none transition-all duration-200 placeholder:text-[#99a4bc] hover:border-[#c8d3fb] hover:bg-[#fbfcff] focus:border-[#b7c5ef] focus:bg-white focus:ring-4 focus:ring-[rgba(74,92,255,0.08)] sm:text-sm';

  return (
    <div className={flush ? 'mt-0' : compact ? 'mt-0.5' : 'mt-2'}>
      <div className={`flex justify-between items-center ${flush ? 'h-1 mb-0' : 'mb-1'}`}>
        {label && (
          <label className="block text-[13px] font-semibold text-[#4d5b78]">
            {label}
          </label>
        )}
        <small className={`ml-auto text-[12px] text-[#7f8aa6] ${flush ? '-translate-y-2 leading-none text-[0.78rem]' : ''}`}>
          {value.length}/{maxLength} max
        </small>
      </div>

      {multiline ? (
        <textarea
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          rows={rows}
          placeholder={placeholder}
          className={inputClasses}
        />
      ) : (
        <input
          type="text"
          value={value}
          maxLength={maxLength}
          onChange={onChange}
          placeholder={placeholder}
          className={inputClasses}
        />
      )}
    </div>
  );
};

export default InputWithCounter;
